module.exports = __webpack_public_path__ + "assets/2e565f356793e6ffd3610754a298b3f0.mp3";